import React, { useEffect, type ReactNode } from 'react';
import { addMetaTags } from '@atlassian/jira-servicedesk-legacy-bridges-common/src/utils/meta-tag-support/index.tsx';
import { useProjectContext } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/project-context/index.tsx';
import { WRMModuleLoader } from '@atlassian/jira-wrm/src/wrm-module-loader/index.tsx';

type Props = {
	children: ReactNode;
};

const LegacyAutomationModules = ({ children }: Props) => {
	const data = useProjectContext();

	const { key: projectKey, id: projectId } = data ? data.project : { key: '', id: null };

	useEffect(() => {
		let resetTags: (() => void) | null = null;
		if (projectId !== null) {
			resetTags = addMetaTags({
				projectKey,
				projectId: String(projectId),
			});
		}
		return () => {
			resetTags && resetTags();
		};
	}, [projectKey, projectId]);

	return (
		<WRMModuleLoader modules={['wrc!sd.project.settings.automation.modules']}>
			{/* @ts-expect-error - TS2769 - No overload matches this call. */}
			{() => children}
		</WRMModuleLoader>
	);
};

export default LegacyAutomationModules;
